<!--隐形库存-->
<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="4">
              <el-select v-model="minyear" placeholder="" style="width:80px" size="mini">
                <el-option
                  v-for="item in getYearList()"
                  :key="item+''"
                  :label="item+''"
                  :value="item+''">
                </el-option>
              </el-select>
              <el-select v-model="minmonth" placeholder="" style="width:65px" size="mini">
                <el-option
                  v-for="item in monthList"
                  :key="item+''"
                  :label="item+''"
                  :value="item+''">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width: 130px" size="mini">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                          :isShowCheckBox="false" :treeWidth="350"
                          :treeHeight="300" :searchText="seedname" :inputSize="'mini'"
                          placeholder="请选择商品"
                          @check="checktree">
              </CommonTree>
            </el-col>
            <el-col :span="4">
              <CommonTree :treeWidth="350" :treeHeight="300"
                          ref="treeGroupSeed" :defineDataSource="true" @bindData="bindTreeData" :inputSize="'mini'"
                          @afterBindTree="afterBindTree"
                          :onlyShowGroupType="true"
                          @check="checktree1" :canDelete="false"
                          :needTopNode="false"
                          placeholder="请选择类别">
              </CommonTree>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <el-button icon="el-icon-download" v-on:click="excelPort" size="mini">导出</el-button>
            </el-col>
            <el-col :span="4">
              <!--<el-button icon="el-icon-printer" @click="printBar">打印条码</el-button>-->
              <el-button type="primary" v-on:click="showCert" size="mini" v-if="!bimanage">维护证书</el-button>
              <el-button type="primary" v-on:click="showEndtime" size="mini">查明细</el-button>
            </el-col>
          </el-col>
        </div>
        <div v-if="!afterSearch" style="font-size: x-large;color: #ff6600;">请选择完查询条件后，点击“搜索”按钮</div>
        <el-table
          :data="tableData"
          :height="eltableheight"
          size="mini"
          :summary-method="getSummaries"
          show-summary
          border :row-class-name="tableRowClassName"
          style="width: 100%;">
          <el-table-column label="仓库" fixed align="left" header-align="center" width="144" prop="cangkuname">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 98%;height:24px;"
                   :title="scope.row.cangkuname">{{ scope.row.cangkuname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="名称" fixed align="left" header-align="center" width="260" prop="seedname">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 98%;height:24px;"
                   :title="scope.row.seedname" v-if="scope.row.cangkuname!='小计'">{{ scope.row.seedname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="编码" align="left" header-align="center" width="140">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 98%;height:24px;"
                   :title="scope.row.seedcode" v-if="scope.row.seedcode!='小计'">{{ scope.row.seedcode }}
              </div>
            </template>
          </el-table-column>
          <!--<el-table-column label="价值" align="right" header-align="center" width="70" prop="subtractnum">-->
          <!--<template slot-scope="scope">-->
          <!--{{scope.row.costprice*scope.row.subtractnum}}-->
          <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column label="期初" align="right" header-align="center" width="70" prop="qichu">
            <template slot-scope="scope">
              {{scope.row.qichu == 0 ? "" : scope.row.qichu}}
            </template>
          </el-table-column>
          <el-table-column label="入库" align="right" header-align="center" width="70" prop="debitnum">
            <template slot-scope="scope">
              {{scope.row.debitnum == 0 ? "" : scope.row.debitnum}}
            </template>
          </el-table-column>
          <el-table-column label="出库" align="right" header-align="center" width="70" prop="creditnum">
            <template slot-scope="scope">
              {{scope.row.creditnum == 0 ? "" : scope.row.creditnum}}
            </template>
          </el-table-column>
          <el-table-column label="结存" align="right" header-align="center" width="70" prop="subtractnum">
            <template slot-scope="scope">
              {{scope.row.subtractnum == 0 ? "" : scope.row.subtractnum}}
            </template>
          </el-table-column>
          <el-table-column label="条码量" align="right" header-align="center" width="70" prop="yxall">
            <template slot-scope="scope">
              {{scope.row.yxall == 0 ? "" : scope.row.yxall}}
            </template>
          </el-table-column>
          <el-table-column label="过期" align="right" header-align="center" width="70" prop="yxshixiao">
            <template slot-scope="scope">
              {{scope.row.yxshixiao == 0 ? "" : scope.row.yxshixiao}}
            </template>
          </el-table-column>
          <el-table-column label="14个月" align="right" header-align="center" width="70" prop="yxchaoqi">
            <template slot-scope="scope">
              {{scope.row.yxchaoqi == 0 ? "" : scope.row.yxchaoqi}}
            </template>
          </el-table-column>
          <el-table-column label="待发货" align="right" header-align="center" width="70" prop="deliverying">
            <template slot-scope="scope">
              {{scope.row.deliverying == 0 ? "" : scope.row.deliverying}}
            </template>
          </el-table-column>
          <el-table-column label="采购中" align="right" header-align="center" width="70" prop="buynum">
            <template slot-scope="scope">
              {{scope.row.buynum == 0 ? "" : scope.row.buynum}}
            </template>
          </el-table-column>
          <el-table-column label="调拨中" align="right" header-align="center" width="70" prop="transfernum">
            <template slot-scope="scope">
              {{scope.row.transfernum == 0 ? "" : scope.row.transfernum}}
            </template>
          </el-table-column>
          <!--<el-table-column label="预警" align="right" header-align="center" width="70" prop="minstore">-->
            <!--<template slot-scope="scope">-->
              <!--{{scope.row.minstore == 0 ? "" : scope.row.minstore}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column label="超库存" align="right" header-align="center" width="80" prop="surplus">-->
            <!--<template slot-scope="scope">-->
              <!--{{scope.row.surplus == 0 ? "" : scope.row.surplus}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column label="需补货" align="right" header-align="center" width="70" prop="maxstore">-->
            <!--<template slot-scope="scope">-->
              <!--{{scope.row.maxstore == 0 ? "" : scope.row.maxstore}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column fixed="right" label="操作" header-align="center" align="left" width="120">
            <template slot-scope="scope">
              <!--<el-button size="mini" v-if="allowTransfer&&scope.row.cangkucode!='all'"-->
                         <!--@click="handleTransfer(scope.$index, scope.row)">调拨-->
              <!--</el-button>-->
              <!--<el-button size="mini" v-if="allowBuy&&scope.row.cangkucode!='all'"-->
                         <!--@click="handleBuy(scope.$index, scope.row)">采购-->
              <!--</el-button>-->
              <el-button
                size="mini" v-if="scope.row.cangkucode!='all'"
                @click="handleEdit(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
    <StorageView ref="DataContactView" :showyinxing="true"></StorageView>
    <Storeprintbarcode ref="printbarcode"></Storeprintbarcode>
    <BuyorderDetailEdit ref="BuyorderDetailEdit" @bindGrid="bindGrid()"></BuyorderDetailEdit>
    <AllocationEditNew ref="DataContactEdit2" @bindGrid="bindGrid"></AllocationEditNew>
    <certList ref="certList1"></certList>
    <searchEndtimeList ref="searchEndtimeList1"></searchEndtimeList>
  </div>
</template>
<script>

  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getGoodsListWithStore} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import certList from '../../set/cert/certList'
  import searchEndtimeList from '../../set/cert/searchEndtimeList'
  import StorageView from './StorageView';
  import Storeprintbarcode from './Storeprintbarcode';
  import BuyorderDetailEdit from '@/components/testorder/buyagreement/BuyorderDetailEdit';
  import AllocationEditNew from '@/components/warehouse/AllocationEditNew';

  export default {

    name: 'StorageYinxin',
    data() {

      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        afterSearch: false,
        userInfoModel: {},
        msg: 'Welcome to Your Vue.js App',
        addVisible: false,
        dialogFormVisible: false,
        eltableheight: 300,
        searchdata: "",
        cangkucode: "",
        bimanage:false,
        jxcstoreData: [],
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: yearnow,
        maxmonth: monthnow,
        yearflag: '',
        loading: true,
        status: "",
        seedcode: "",
        seedname: "",
        iscsshow: '',
        year: '',
        guids: "",
        isdeliverShow: true,
        gu: "",
        allowTransfer: false,//允许调拨
        allowBuy: false,//允许采购
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//月份
        categoryData:[],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0,
        },
        tableData: [],
        timer:null,
        oldtableData: [],//备份tableData
      }
    },
    props: {
      mystatus: {
        default: '200'
      },
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 buy、 store、machining、jiesuan、customerservice ， 分别对应订单、采购单、库存、加工、结算、客服 等菜单角色
      }
    },
    methods: {
      printBar() {
        this.$refs.printbarcode.show();
      },
      //唯一码查询
      showCert() {
        this.$refs.certList1.show()
      },
      showEndtime(){
        this.$refs.searchEndtimeList1.show(this.categoryData)
      },
      //导出excel
      excelPort() {
        let header1 = ["仓库", "名称", "编码", "期初", "入库", "出库", "结存"]//, "采购中", "调拨中", "预警", "超库存", "需补货"]
        let column1 = ["cangkuname", "seedname", "seedcode", "qichu", "debitnum", "creditnum", "subtractnum"]//, "buynum", "transfernum", "minstore", "surplus", "maxstore"]
        var name = new Date();
        if (this.cangkucode) {
          for (let i = 0; i < this.jxcstoreData.length; i++) {
            if (this.cangkucode == this.jxcstoreData[i].cangkucode) {
              name = this.jxcstoreData[i].cangkuname + this.fmtDate(name);
              break
            }
          }
        } else {
          name = "全部库存" + this.fmtDate(name);
        }


        this.$exportExcel(header1, column1, this.tableData, name)
      },
      //汇总
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          var values = [];
          data.map(function (item) {
            if (item.cangkuname != '小计') {
              values.push(Number(item[column.property]));
            }
          });
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      //时间格式化
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      tableRowClassName({row, rowIndex}) {
        if (row.cangkucode === 'all') {
          return 'warning-row';
        }
        return '';
      },
      handleEdit(index, row) {//查看页面
        this.$refs.DataContactView.initData(row, this.minyear, this.minmonth, this.minyear, this.minmonth);
      },
      handleTransfer(index, item) {//调拨页面
        this.$refs.DataContactEdit2.show()
        this.$refs.DataContactEdit2.initData(item)
      },
      handleBuy(index, item) {//采购页面
        this.$refs.BuyorderDetailEdit.show()
        this.$refs.BuyorderDetailEdit.initData(item)
      },
      //年份
      getYearList() {
        var arr = [];
        var yearnow = new Date().getFullYear();
        for (let i = yearnow; i >= 2022; i--) {
          arr.push(i)
        }
        return arr
      },
      checktree1(guids, names, arr) {
        this.guids = guids;
      },
      //具体商品选择 根据前台数据筛选
      checktree(guids, names, arr) {
        this.seedcode = guids;
        this.seedname = names
        // if (names == '') {
        //   //this.bindGrid()
        // } else {
        //   this.seedname = names;
        //   var data = []
        //   for (let i = 0; i < this.oldtableData.length; i++) {
        //     if (this.oldtableData[i].seedname == this.seedname) {
        //       data.push(Object.assign({}, this.oldtableData[i]))
        //     }
        //   }
        //   this.tableData = data;
        // }
      },

      //商品类别
      bindTreeData() {//绑定分类树
        this.$refs.treeGroupSeed.bindData(() => {
          return getGoodsTree({
            onlyShowGroupType: false,
            hideseed:true,
            onlyShowEnabledGroupType: true,
            categorystarts: '010;006',
            isyinxin: 'yx',
            filltemplates:'10;40'
          });
        })
      },
      //商品
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1, categorystarts: '010;006', isyinxin:  'yx', filltemplates:'10;40'})
        })
      },
      afterBindTree(result) {
        //if (result.length > 0 && result[0].hasChildren && result[0].children[0].hasChildren) {//有3层分类（找眼镜网产品过多，只能分类别查）
        this.categoryData=result;
        if(result.length==0) {
          if (!this.bimanage) {
            this.$message({
              message: '请维护隐形商品的证书！',
              type: 'error'
            })
          }
          return;
        }
        this.$refs.treeGroupSeed.handleNodeClick(result[result.length-1]);
        //}
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj;
          var storecout=this.jxcstoreData.length;
          if (storecout > 0){
            this.cangkucode = this.jxcstoreData[storecout==2?1:0].cangkucode;
          }

          this.allowBuy = this.roletype == 'buy' || this.roletype == 'order';
          if (this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == "") {
            this.allowTransfer = this.roletype == 'buy' || this.roletype == 'order';
          }
          this.jxcstoreData.unshift({
            cangkuname: "全部仓库",
            cangkucode: ''
          })

          this.afterSearch = false;
          this.bindGrid();
        })
      },
      bindGrid() {//绑定列表
        this.afterSearch = true;
        this.tableData = []
        this.oldtableData = []
        if(this.timer){
          clearInterval(this.timer);
          this.timer = null;
        }

        getGoodsListWithStore({
          searchdata: this.searchdata,//产品名称（保留 暂不考虑）
          categorycode: this.guids,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          seedcode: this.seedcode,
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
          isyinxin:  'yx'
        }).then(response => {
          this.oldtableData = response.data.obj
          this.eltableheight=this.oldtableData.length==0?this.tableHeight(190): this.tableHeight(this.bimanage?30:90)

          var self = this;
          var index = 0;
          for (var i = 0; i < this.oldtableData.length; i++) {
            if (i < 25) {
              index = i;
              this.tableData.push(Object.assign({}, this.oldtableData[i]))
            } else {
              break;
            }
          }

          self.timer = setInterval(() => {
            var start= index + 1;
            var maxrow=index+150+1;

            for (var i = start; i <maxrow; i++) {
              if (i < self.oldtableData.length) {
                index = i;
                self.tableData.push(Object.assign({}, self.oldtableData[i]))
              }else {
                break;
              }
            }
            if(index>=self.oldtableData.length-1){
              clearInterval(self.timer);
              self.timer = null;
            }
          }, 1000)

        }).catch((error) => {
          console.log(error)
        });
      },
    },

    mounted() {
      this.bimanage=this.$route.query.bimanage?true:false;
    },
    components: {
      StorageView,
      Storeprintbarcode,
      BuyorderDetailEdit,
      AllocationEditNew,
      certList,
      searchEndtimeList
    }
  }
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/StorageYinxin.vue